import React, { Fragment } from 'react';

import Loader from '../components/loader';

const withLoadingFallback = (Component) => function withLoadingFallbackComponent({ isLoading, fallback = <Loader />, ...props }) {
  if (!isLoading) return (<Component {...props} />);
  return fallback;
};

export { withLoadingFallback };

const Suspended = withLoadingFallback(Fragment);

export { Suspended };
